/*eslint-disable*/
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

// core components
import Footer from "components/Footer/Footer";
import SportappHeader from "customComponents/SportappHeader/Header";
import Parallax from "components/Parallax/Parallax";

import landingPageStyle from "assets/jss/material-kit-pro-react/views/landingPageStyle.js";
import profilePageStyle from "assets/jss/material-kit-pro-react/views/profilePageStyle";

import ssbBackground from "customAssets/img/ssb_background.png";
import EventList from "./components/EventList";

const styles = () => {
	return {
		...landingPageStyle,
		...profilePageStyle,
		logoImg: {
			width: "100%",
			height: "auto",
		},
		container: {
			...landingPageStyle.container,
			paddingTop: 10,
		},
		textCenter: {
			textAlign: "center",
		},
	};
};

const useStyles = makeStyles(styles);
export default function EventsPage() {
	React.useEffect(() => {
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;
	}, []);

	const classes = useStyles();
	return (
		<div>
			<SportappHeader />
			<Parallax
				image={ssbBackground}
				filter="dark"
				className={classes.parallax}
			/>
			<div className={classNames(classes.main, classes.mainRaised)}>
				<div className={classes.container}>
					<EventList />
				</div>
			</div>
			<Footer
				content={
					<div>
						<div className={classes.left}>
							<List className={classes.list}>
								<ListItem className={classes.inlineBlock}>
									<a href="/impressum/" className={classes.block}>
										Impressum
									</a>
								</ListItem>
								<ListItem className={classes.inlineBlock}>
									<a href="/datenschutz/" className={classes.block}>
										Datenschutzerklärung
									</a>
								</ListItem>
							</List>
						</div>
						<div className={classes.right}>
							&copy; {1900 + new Date().getYear()} Solinger Sportbund e.V.
						</div>
					</div>
				}
			/>
		</div>
	);
}

EventsPage.propTypes = {
	classes: PropTypes.object,
};
